import { useReducer } from 'react';

const actions = {
  input: 'input',
  load: 'load',
  reset: 'reset',
  submit: 'submit',
  submitOk: 'submitOk',
  submitError: 'submitError'
};

const initialState = {
  isSubmitting: false,
  submitError: '',
  data: {}
};

const formReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case actions.input:
      newState = { ...state, data: { ...state.data, [action.field]: action.value } };
      break;
    case actions.load:
      newState = {
        ...state,
        data: { ...action.data }
      };
      break;
    case actions.reset:
      newState = {
        ...state,
        isSubmitting: false,
        submitError: ''
      };
      break;
    case actions.submit:
      newState = {
        ...state,
        isSubmitting: true
      };
      break;
    case actions.submitOk:
      newState = {
        ...state,
        submitError: '',
        isSubmitting: false
      };
      break;
    case actions.submitError:
      newState = {
        ...state,
        isSubmitting: false,
        submitError: action.error
      };
      break;

    default:
      throw new Error(`'${action.type}' action is not supported by form reducer`);
  }
  return newState;
};

export const useForm = (initialData = {}) => {
  const [state, dispatch] = useReducer(formReducer, { ...initialState, data: initialData });

  const load = (data) => {
    dispatch({ type: actions.load, data });
  };

  const input = (value, field) => {
    dispatch({ type: actions.input, field, value });
  };

  const reset = () => dispatch({ type: actions.reset });

  const submitStart = () => dispatch({ type: actions.submit });
  const submitOk = () => {
    dispatch({ type: actions.submitOk });
  };
  const submitError = (error) => dispatch({ type: actions.submitError, error });

  return {
    data: state.data,
    load,
    reset,
    input,
    submitStart,
    submitOk,
    submitError,
    error: state.submitError,
    isSubmitting: state.isSubmitting
  };
};
